module.exports = __webpack_public_path__ + "media/images/athletes/4308-07c8be9dbc1834703318ee0b53428abd.png";